import { Component, OnInit, Input } from '@angular/core';

import { WizardService } from 'app/main/wizard-n35/services/wizard.service';
import * as backInter from 'app/auth/auth-data.model';

import { lang_resultados35 } from 'app/idiomas/i18n/resultados35/resultados35.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

@Component({
  selector: 'app-calificacion-final',
  templateUrl: './calificacion-final.component.html',
  styleUrls: ['./calificacion-final.component.scss']
})
export class CalificacionFinalComponent implements OnInit {
  @Input() productoID: any;
  @Input() centroDeTrabajoId:any;

  cargando:boolean=true;
  urlCTIndividual:any;
  calificacion:any;
  color:any;
  totalColaboradores:number;

  constructor(
    private wizardService: WizardService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
  ) {
    lang_resultados35.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    this.getGeneralesCT();
  }

  getGeneralesCT(){
    let data={
      productoId: this.productoID,
      id_CT:this.centroDeTrabajoId
    }
    if(localStorage.getItem('empresaPadre')){
      this.urlCTIndividual=localStorage.getItem('empresaPadre');
    }
    else{
      this.urlCTIndividual="";
    }
    this.wizardService.getGeneralesCT(this.urlCTIndividual, data).subscribe( (datos: backInter.GeneralesCentrosDeTrabajo) => {
      console.log(datos);
      if(datos.totalColaboradores<50){
        this.totalColaboradores=1;
      }
      else{
        this.totalColaboradores=2;
      }
      this.getTableros();
    });
  }

  getTableros(){
    let data={
      productoId: this.productoID,
      id_CT:this.centroDeTrabajoId
    }
    if(localStorage.getItem('empresaPadre')){
      this.urlCTIndividual=localStorage.getItem('empresaPadre');
    }
    else{
      this.urlCTIndividual="";
    }

    this.wizardService.getTableros(this.urlCTIndividual, data).subscribe( (datos: backInter.tableroGlobal) => {
      console.log(datos);
        this.calificacion = datos.total['value'];
        this.color=datos.total['valorColor'];
        this.cargando=false;
    });
  }

}
